<template>
	<div style="background: #fff; height: 280px;margin: 0 auto;">
		<div class="advert_warp" style=" border: 0px solid #424242;">
			<div v-for="(item,index) in res" @click="toadvlink(item.advlink)" style=" float: left;
    width: calc((100% - 40px)/1);
    margin-right: 10px;
    height: 280px;
    overflow: hidden;">
				<img :src="   item.picture" alt="" style=" width: 100%;
    height: 75%;">
			</div>

		</div>
	</div>

</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				res: ''
			}
		},
		async mounted() {
			let res = await http.post('api/Common/index', {
				model: 'gg',
				type: 'content',
				mid: '1',
				fid: '10'
			})
			this.res = res.data.data.list.data.slice(0, 1)
		},
		methods: {
			toadvlink(id) {
				window.open(id)
			}
		}
	}
</script>

<style>
	.advert_warp::after {
		content: '';
		display: block;
		clear: both;
	}

	/* @media screen and (min-width: 1560px) { */
	/* .advert_warp{
        width: 90%;
        margin: 0 auto;
        height: 80%;
    } */
	/* .advert_warp > div{
        width: 23.93% !important;
    }
    }; */
	/* @media screen and (min-width: 1460px) {
    .advert_warp > div{
        width: 23.83% !important;
    }
    }; */
	.advert_warp {
		/* max-width: 1600px; */
		border: 0px solid #424242;
	}

	.advert_warp>div {
		float: left;
		width: calc((100% - 0px));
		margin-right: 10px;
		height: 250px;
		overflow: hidden;
		/* border: 1px solid #424242; */
	}

	.advert_warp>div>img {
		width: 100%;
		height: 100%;
	}
</style>
